// extracted by mini-css-extract-plugin
module.exports = {"offerCard":"FurnitureOfferCard_offerCard__HDXfB","offerCard__left":"FurnitureOfferCard_offerCard__left__r4irF","offerCard__right":"FurnitureOfferCard_offerCard__right__UTzob"};